import { lazy } from 'react';
import 'react-native-gesture-handler';

import { wrapLazyBottomTabNavigatorScreen } from '../../functions/navigation/utils/wrapBottomTabNavigatorScreen';

const CommunityPageContent = lazy(
  () => import('./components/CommunityPageContent'),
);

export const CommunityPage = wrapLazyBottomTabNavigatorScreen(
  () => {
    return <CommunityPageContent />;
  },
  {
    headerShown: false,
  },
);
